import { render } from "./obitSwitchUrl.vue?vue&type=template&id=6b3dc431"
import script from "./obitSwitchUrl.vue?vue&type=script&lang=js"
export * from "./obitSwitchUrl.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__